// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'bulb-solid';

export const Component = () => (
  <path d='M15.775 20.11c0 .335-.144.526-.479.526h-5.89c-.336 0-.48-.191-.48-.527 0-.335.144-.479.48-.479h5.89c.335 0 .479.144.479.48Zm-.479 1.484h-5.89c-.336 0-.48.143-.48.479 0 .335.144.526.48.526h.526c.144.527.431 1.006.862 1.39.43.383.958.574 1.58.574.575 0 1.102-.191 1.533-.575.431-.383.719-.861.862-1.389h.526c.335 0 .48-.191.48-.526s-.145-.48-.48-.48h.001ZM12.327 1h.048-.191c-1.964 0-3.688.719-5.077 2.107C5.718 4.495 5 6.22 5 8.184v.191c0 1.39.719 3.305 2.203 5.747 1.15 1.82 1.724 3.16 1.724 4.023 0 .335.144.526.48.526h5.89c.335 0 .479-.191.479-.526 0-.767.575-2.107 1.724-4.023 1.484-2.347 2.203-4.263 2.203-5.747v-.191c0-1.964-.719-3.688-2.107-5.077C16.208 1.718 14.483 1 12.52 1h-.192Z' />
);

export const viewBox = '0 0 25 25';
